'use strict';

var React = require('react'),
    classSet = require('react/lib/cx'),
    { PropTypes } = React,
    formatTime = require('../utils/formatTime'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./TrackList.less');

var TrackList = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    tracks: PropTypes.array.isRequired,
    activeTrackIndex: PropTypes.number.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired
  },

  getCSSModifiers() {
    return [
      this.props.isPlaying && 'active',
    ];
  },

  render() {
    return (
      <ul className='TrackList'>
        {this.renderTracks()}
      </ul>
    );
  },

  renderTracks() {
    var { activeTrackIndex } = this.props;

    return this.props.tracks.map((track, index) => (
      <li className={classSet({
             'TrackList-track': true,
             'TrackList-track--active': index === activeTrackIndex
           })}
           onClick={this.handleSelect.bind(this, index)}
           key={index}>

        <span className='TrackList-trackTitle'>
          {track.title}
        </span>

        <span className='TrackList-trackDuration'>
          {formatTime(track.duration)}
        </span>
      </li>
    ));
  },

  handleSelect(index) {
    this.props.onSelect(index);
  }
});

module.exports = TrackList;



/** WEBPACK FOOTER **
 ** ./molecules/TrackList.jsx
 **/